import { render } from "./worker-program.vue?vue&type=template&id=0ff9a5b4"
import script from "./worker-program.vue?vue&type=script&lang=js"
export * from "./worker-program.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__